/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:15:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 19:18:07
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/LegalCategory/Root/index.tsx
 */
import React from 'react';
import { useDispatch } from 'react-redux';

import HOC from '../HOC';
// import {
//   getContent,
//   getCollapse,
//   onCollapseChange,
//   getLoaded,
//   getMoveList,
// } from '../slice';
// import Table from '../Table';
// import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
// import Top from 'src/pages/SalesChannelCategory/Components/Card';
import { useI18n } from 'src/hooks/useRouterChange';
import RootModal from 'src/pages/SalesChannelCategory/Components/EditModal/Root';
import Header from 'src/pages/SalesChannelCategory/Components/Header';
import WrapperRoot from 'src/pages/SalesChannelCategory/Components/RootWrapper';
import Card from 'src/pages/SalesChannelCategory/PagesCategory/LegalCategory/Card';
import { submitChange } from 'src/pages/SalesChannelCategory/PagesCategory/LegalCategory/EditModal/tools';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { onDataUpdate } from '../slice';

const Root = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const {
    data,
    moveList,
    salesChannelUuid,
    userPermissions,
    setShowModal,
    setModalTitle,
    setModalContent,
    onModalCancel,
  } = props;
  //console.log(salesChannelUuid);
  const { uuid, name, urlSlug } = data || {};

  const handleOnDataUpdate = (data: any) => {
    _d(onDataUpdate({ data }));
    onModalCancel();
  };

  //====request

  const submissionId = `postCategoryLegal${salesChannelUuid}`;
  const requestId = [submissionId];

  const _submitChange = ({ urlSlug, name }) => {
    return submitChange({
      salesChannelUuid,
      selfUuid: uuid,
      requestId: submissionId,
      urlSlug,
      name,
      onOk: handleOnDataUpdate,
      parentUuid: null,
    });
  };
  //===request

  const onEdit = () => {
    setModalTitle(getI18n('salesChannelCategoryPages.index.editCategory'));
    setModalContent(
      <RootModal
        requestId={requestId}
        onSubmit={_submitChange}
        onOk={handleOnDataUpdate}
        salesChannelUuid={salesChannelUuid}
        onCancel={onModalCancel}
        name={name}
        urlSlug={urlSlug}
        uuid={uuid}
        slugCheckingUrl={'portal/salesChannel/category/legal/checkUrlSlug'}
      />,
    );
    setShowModal(true);
  };

  return (
    <React.Fragment>
      <Card
        contentList={[
          [
            {
              label: getI18n('general.categoryName'),
              value: name,
            },
            {
              label: getI18n('general.uRLSlug'),
              value: urlSlug,
            },
          ],
        ]}
        // name={name}
        // slug={urlSlug}
        // uuid={`rootLegal${uuid}`}
        // products={salesChannelItems}
        moveList={moveList}
        // salesChannelUuid={salesChannelUuid}
        // isRoot
        canEdit={userPermissions.canCreate}
        onEdit={onEdit}
      />
    </React.Fragment>
  );
};

export { Root };

export default WrapperRoot(
  HOC(Root, {
    titleGenerator: (data) => {
      const { name, fullUrl } = data;
      return (
        <Header
          title={name}
          url={fullUrl}
          subTitle={getI18nFromGeneral(
            'general.hOCTitle.legalCategoryRootSubTitle',
          )}
        />
      );
    },
  }),
);
